import { GetStateForWorkOrderStatus } from "akademika/akamont/utils/WorkOrderStatusUtil";
import { Routes } from "akademika/akamont/constants/Routes";
import { WorkOrderListFilters } from "../../models/WorkOrderListFilters";
import JSONModel from "sap/ui/model/json/JSONModel";
import { IsUserInternal } from "akademika/akamont/services/AuthService";
import { FilterController } from "../sharedControllers/FilterController";
import { AllWorkOrderStatuses } from "../../constants/WorkOrderStatuses";
import {
  CsvColumnData,
  ExportCSV,
  FormatDateTimeForCsv,
  FormatPriceForCsv,
} from "../../utils/ExportCSV";
import { FormatDate } from "akademika/akamont/utils/FormatUtil";

/**
 * @namespace akademika.akamont.pages.workOrderList
 */
export default class WorkOrderList extends FilterController {
  route = Routes.WORK_ORDER_LIST;
  parentRoute = Routes.DASHBOARD;

  public override onInit() {
    super.onInit();
    const defaultFilters: WorkOrderListFilters = {
      workOrderId: undefined,
      businessUnitIds: undefined,
      plannedDate: { from: undefined, to: undefined },
      creationDate: { from: undefined, to: undefined },
      creatorUserIds: undefined,
      documentNumber: undefined,
      partnerId: undefined,
      statuses: IsUserInternal()
        ? AllWorkOrderStatuses.filter(
            (status) =>
              status != "cancelled" && status != "closed" && status != "billed"
          )
        : undefined,
      categories: undefined,
      serviceIds: undefined,
      contractIds: undefined,
    };
    this.initFilters(defaultFilters, "api/WorkOrder/GetWorkOrderList");
  }

  public async onRouteMatched() {
    this.fetchModel("api/WorkOrder/GetWorkOrderFilterOptions", "filterOptions");
    this.setModel(new JSONModel({ value: IsUserInternal() }), "isUserInternal");
  }

  public getStateForWorkOrderStatus = GetStateForWorkOrderStatus;

  public async onWorkOrderDetails(workOrderId: number) {
    const targetRoute = IsUserInternal()
      ? Routes.WORK_ORDER_DETAILS_INTERNAL
      : Routes.WORK_ORDER_DETAILS_PARTNER;

    this.navTo(targetRoute, { workOrderId });
  }

  public async onNewWorkOrder() {
    this.navTo(Routes.WORK_ORDER_ADD);
  }

  public onExportCSV() {
    const content: CsvColumnData[] = [
      { header: this.translate("id"), property: "workOrderId" },
      { header: this.translate("partner"), property: "partnerName" },
      { header: this.translate("documentNumber"), property: "documentNumber" },
      {
        header: this.translate("creationDate"),
        property: "creationDate",
        formatter: FormatDateTimeForCsv,
      },
      {
        header: this.translate("plannedDate"),
        property: "plannedDate",
        formatter: FormatDate,
      },
      {
        header: this.translate("status"),
        property: "status",
        formatter: this.translate.bind(this),
      },
      { header: this.translate("creator"), property: "creatorUserName" },
      { header: this.translate("businessUnit"), property: "businessUnitName" },
      {
        header: this.translate("deviations"),
        property: "deviationsExist",
        formatter: this.translateBoolean.bind(this),
      },
      {
        header: this.translate("finalAmount"),
        property: "amount",
        formatter: FormatPriceForCsv,
      },
    ];

    ExportCSV(content, this.getModelData(), "workOrderList");
  }
}
